import React from "react";

export const HeaderDRC = ({ setMostrarModal }) => {
    const openModal = () => {
        setMostrarModal(true);
    };
    // const clearDRCTemp = props.clearDRCTemp;

    return (
        <div className="datos-drc-solidos-edicion__top">
            <button
                className="btn btn-outline-info"
                onClick={function (e) {
                    e.preventDefault();
                    // clearDRCTemp();
                    openModal("drc");
                }}
            >
                AGREGAR DRC
            </button>
        </div>
    );
};
